import styles from './student-type-selector.module.scss';
import Dropdown from '../../../components/atoms/dropdown/dropdown';
import { StudentType } from '../../../constants/student-type';

export type Props = {
  onChange: (value: string) => void;
  defaultValue: StudentType;
};

export default function StudentTypeSelector({
  onChange,
  defaultValue,
}: Props) {
  const options = [
    {
      text: `Undergraduate First Year`,
      value: StudentType.FTIC
    },
    {
      text: `Undergraduate Transfer`,
      value: StudentType.Transfer
    }
  ];

  const defaultOption = defaultValue ? defaultValue : options[0].value;

  return (
    <div className={`${styles[`student-type-block`]} mb-md-4 mb-3`}>
      <h3 className={styles[`student-type-heading`]}>First Year or Transfer</h3>
      <label htmlFor='student-type-select' className='mb-2'>Select your admission route for the undergraduate program.</label>
      <div>
        <Dropdown
          ariaLabel='Student Type selector'
          onChange={onChange}
          defaultValue={defaultOption}
          options={options}
          customClass={`${styles[`student-type-dropdown`]}`}
          id='student-type-select'
        />
      </div>
    </div>
  );
}
